
const digest = '4e9331b7a5c006f97681bcababf22d490d0e95acbdd5513ff822de4cbc00f105';
const classes = {"filterForm":"_filterForm_k3qgv_1","wrapperInline":"_wrapperInline_k3qgv_5"};
const css = `._filterForm_k3qgv_1 {
  display: flex;
  align-items: center;
}
._filterForm_k3qgv_1 div._wrapperInline_k3qgv_5 {
  margin-bottom: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  